(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageDeleteController',PublicSiteLanguageDeleteController);

    PublicSiteLanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteLanguage'];

    function PublicSiteLanguageDeleteController($uibModalInstance, entity, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteLanguage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
